export const ValorRpaModuleName = {
    VALORPAYTECH_IPG: 'valorpaytech-ipg' as const,
    VALORPAYTECH_WORKFLOWS: 'valorpaytech-workflows' as const,
} as const;

export type ValorRpaModuleName =
    (typeof ValorRpaModuleName)[keyof typeof ValorRpaModuleName];
